import { IAuthPromo } from '@components/cards/AuthPromo/types';

export const authPromoSliderData: IAuthPromo[] = [
  {
    image: '/img/auth/step-1-back.png',
    imageCenter: '/img/auth/step-1-center.png',
    imageRight: '/img/auth/step-1-right.png',
    imageLeft: '/img/auth/step-1-left.png',
    title: (
      <>
      <div>
          <span className="yellow">$8{' '}</span>
          <span className="yellow">Million </span>
      </div>
      <div>
          <span>WELCOME{' '}</span>
          <span>OFFER</span>
        </div>
      </>
    ),
    list: [
      'Customized welcome bonus.',
      'Enter your wallet to see what you’ve won.',
      'Up to 65% rewards',
    ],
  },
  {
    image: '/img/auth/step-2-back.png',
    imageCenter: '/img/auth/step-2-center.png',
    imageRight: '/img/auth/step-2-right.png',
    imageLeft: '/img/auth/step-2-left.png',
    title: (
      <>

      <div>
          <span className="yellow">Rewards</span>
          <span className="yellow">That </span>
      </div>
      <div>
          <span>Move{' '}</span>
          <span>You</span>
        </div>
      </>
    ),
    list: [
      'Slide between rakeback and lossback',
      'Have your cashback how you want it',
      'Unlock tailored bonuses',
    ],
  },
  {
    image: '/img/auth/step-3-back.png',
    imageCenter: '/img/auth/step-3-center.png',
    imageRight: '/img/auth/step-3-right.png',
    imageLeft: '/img/auth/step-3-left.png',
    title: (
      <>

            <div>
          <span className="yellow">More</span>
          <span className="yellow">than </span>
      </div>
      <div>
          <span>a{' '}</span>
          <span>player</span>
        </div>

      </>
    ),
    list: ['Stack your XP', 'Back the platform', 'Reap the rewards'],
  },
];
